module.exports = __webpack_public_path__ + "static/img/cpjzx_4@2x.4d1b3ad0.png";